import toast from 'react-hot-toast';

export function useSharePoll() {
    const share = async (userSlug: string, pollSlug: string, _title: string) => {
        const url = `${window.location.origin}/${userSlug}/${pollSlug}`;
        try {
            await navigator.clipboard.writeText(url);
            toast.success('Enlace copiado');
        } catch {
            toast.error('No se pudo copiar el enlace');
        }
    };

    const shareWhatsApp = (userSlug: string, pollSlug: string, title: string) => {
        const url = `${window.location.origin}/${userSlug}/${pollSlug}`;
        window.open(
            `https://wa.me/?text=${encodeURIComponent(`Vota en mi encuesta "${title}": ${url}`)}`,
            '_blank'
        );
    };

    return { share, shareWhatsApp };
}
